import React from "react";
import { useTheme, THEMES } from "../../context/ThemeContext";
import { HiSun, HiMoon } from "react-icons/hi";

/**
 * ThemeToggle - Button component to toggle between light and dark modes
 */
const ThemeToggle = ({ className = "" }) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`p-2 rounded-lg transition-colors ${className}`}
      style={{ 
        color: isDark ? '#94a3b8' : '#64748b',
        backgroundColor: 'transparent'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = isDark ? "#334155" : "#f1f5f9";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "transparent";
      }}
      title={`Switch to ${isDark ? "light" : "dark"} mode`}
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
    >
      {isDark ? (
        <HiSun className="w-5 h-5" />
      ) : (
        <HiMoon className="w-5 h-5" />
      )}
    </button>
  );
};

/**
 * ThemeSelector - Dropdown to select between light, dark, and system themes
 */
export const ThemeSelector = ({ className = "" }) => {
  const { theme, setTheme } = useTheme();

  return (
    <select
      value={theme}
      onChange={(e) => setTheme(e.target.value)}
      className={`px-3 py-2 text-sm rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500/20 ${className}`}
      style={{ backgroundColor: '#ffffff', color: '#1e293b', borderColor: '#e2e8f0' }}
      aria-label="Select theme"
    >
      <option value={THEMES.LIGHT}>Light</option>
      <option value={THEMES.DARK}>Dark</option>
      <option value={THEMES.SYSTEM}>System</option>
    </select>
  );
};

export default ThemeToggle;
